import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { BehaviorSubject } from 'rxjs'
import { WeekSchedule } from '../work-schedule'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { DailyScheduleEditComponent } from '../daily-schedule-edit/daily-schedule-edit.component'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-weekly-schedule-edit',
  templateUrl: './weekly-schedule-edit.component.html',
  styleUrls: ['./weekly-schedule-edit.component.scss'],
  imports: [DailyScheduleEditComponent, AsyncPipe, ElderTranslatePipe],
})
export class WeeklyScheduleEditComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  public readonly week$ = new BehaviorSubject<WeekSchedule>(null)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set weekSchedule(weekSchedule: WeekSchedule) {
    this.week$.next(weekSchedule)
  }
}
